
        import * as module0 from './../../../packs/ui/app/components/ui/_structural/code_sample_modal/code_sample_modal_controller.js'
        const modules = [{name: '..--..--..--packs--ui--app--components--ui---structural--code-sample-modal--code-sample-modal', module: module0, filename: '../../../packs/ui/app/components/ui/_structural/code_sample_modal/code_sample_modal_controller.js'}]
        export default modules;
      